// ============================================================
// LoadingScreen.js
// Branded full-screen loading splash. Extracted from App.js so it
// can serve both the lazy-route <Suspense> fallback (App.js) and
// the authenticated bootstrap states (routes/AuthenticatedApp.jsx)
// without a circular import. Styling lives in the canonical
// src/status-screens.css (.loading-screen*, .logo-*), loaded GLOBALLY
// via index.css — which matters here: this component renders as the
// Suspense fallback BEFORE any lazy chunk's CSS can load.
// ============================================================

import React from 'react';

export default function LoadingScreen({ message = 'Loading…' }) {
  return (
    <div className="loading-screen">
      <div className="loading-screen__content">
        <div className="loading-screen__logo">
          <span className="logo-a">A2Z</span>
          <span className="logo-care">Care</span>
          <span className="logo-hub">Hub</span>
        </div>
        <div className="loading-screen__dots">
          <span /><span /><span />
        </div>
        <p>{message}</p>
      </div>
    </div>
  );
}
